import { render } from "./PinnedFilter.vue?vue&type=template&id=2beae771&scoped=true&ts=true"
import script from "./PinnedFilter.vue?vue&type=script&lang=ts"
export * from "./PinnedFilter.vue?vue&type=script&lang=ts"

import "./PinnedFilter.vue?vue&type=style&index=0&id=2beae771&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2beae771"]])

export default __exports__